export let data = {
  title: "Komisi",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Generate Komisi",
      link: "/komisi/daftar",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};

export let models = [
  {
    value: "App\\Models\\Dokter",
    label: "Dokter"
  },
  {
    value: "App\\Models\\Petugas",
    label: "Petugas"
  }
];
export let periods = [

];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "Periode",
      type: "select",
      placeholder: "Pilih Periode",
      value: "",
      name: "id_periode",
      mandatory: true,
      options: periods,
      colwidth: 4,
      id: "filterDoctor"
    },
    {
      label: "Tampilkan Data",
      type: "select",
      placeholder: "Pilih Data",
      value: "App\\Models\\Dokter",
      name: "model_penerima",
      mandatory: true,
      options: models,
      colwidth: 3,
      id: "filterReference"
    }
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      placeholder: "",
      name:"orderBy",
      value: "desc",
      mandatory: true,
      options: sorts
    }
  ]
};
